module.exports = __webpack_public_path__ + "img/y_p2_dibiao.d675fe4a.svg";